import React from 'react';
import {
  Box,
  Link,
  Text,
  Container,
  Divider,
} from '@chakra-ui/react';

const Footer = () => {
  return (
    <Box as="footer" py={6} mt={8}>
      <Container maxW="1200px">
        <Divider mb={4} />
        <Text 
          textAlign="center" 
          color="gray.600" 
          fontSize="sm"
        >
          Proudly developed and maintained by{' '}
          <Link
            href="https://deebits.com/"
            isExternal
            color="deebits.red"
            fontWeight="medium"
            _hover={{
              textDecoration: 'none',
              color: 'red.600'
            }}
          >
            Deebits Software Engineering (Pvt) Ltd
          </Link>
        </Text>
      </Container>
    </Box>
  );
};

export default Footer; 